module.exports = (__webpack_require__(67))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/object-assign/index.js from dll-reference vendor
// module id = 201
// module chunks = 39